/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Tlm_1Inputs */

const en_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`network_layer`)
};

const ar_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طبقة الشبكة`)
};

const bn_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`network_layer`)
};

const de_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netzwerkschicht`)
};

const es_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`capa_red`)
};

const fr_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`couche_réseau`)
};

const pt_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`camada_de_rede`)
};

const zh_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网络层`)
};

const tr_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ağ_katmanı`)
};

const ru_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`network_layer`)
};

const pl_svc_web_scraping_tlm_1 = /** @type {(inputs: Svc_Web_Scraping_Tlm_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`warstwa_sieci`)
};

/**
* | output |
* | --- |
* | "network_layer" |
*
* @param {Svc_Web_Scraping_Tlm_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_tlm_1 = /** @type {((inputs?: Svc_Web_Scraping_Tlm_1Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Tlm_1Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_tlm_1(inputs)
	if (locale === "bn") return bn_svc_web_scraping_tlm_1(inputs)
	if (locale === "de") return de_svc_web_scraping_tlm_1(inputs)
	if (locale === "es") return es_svc_web_scraping_tlm_1(inputs)
	if (locale === "fr") return fr_svc_web_scraping_tlm_1(inputs)
	if (locale === "pt") return pt_svc_web_scraping_tlm_1(inputs)
	if (locale === "zh") return zh_svc_web_scraping_tlm_1(inputs)
	if (locale === "tr") return tr_svc_web_scraping_tlm_1(inputs)
	if (locale === "ru") return ru_svc_web_scraping_tlm_1(inputs)
	if (locale === "pl") return pl_svc_web_scraping_tlm_1(inputs)
	return en_svc_web_scraping_tlm_1(inputs)
});
export { svc_web_scraping_tlm_1 as "svc_web-scraping_tlm_1" }